import React from 'react';import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';
import StatusContext from '../../../contexts/StatusContext';
import "./searchtext.css"

export const SearchText = ({label, text, disabled, onSearch}) => {

   let {
      isMobile,
    } = React.useContext(StatusContext);
  

  return (
    <div>
        <TextField
          id="outlined-multiline-flexible"
          label={label}
          multiline
          maxRows={2}
          size="small"
          fullWidth
          sx={{ marginLeft:'10px', fontStyle:'italic', width:isMobile()? '100%' : '50%'}}
          InputProps={{
                      style: { color: 'rgb(59, 75, 93)', fontSize: '16px', marginLeft:'-10px'},
                      startAdornment: (
                        <InputAdornment position="start">
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
          InputLabelProps={{
                      style: { fontSize: '16px', marginLeft:'-15px' },
                    
                    }}   
          value = {text} onChange={onSearch}
        />
      </div>
  );

 
};

SearchText.defaultProps = {
  disabled: false,
}
